import { React, Spinner } from 'mondrian-react';
import styles from './styles.module.css';

const FullPageLoader = () => (
  <Spinner isLoading className={styles.FullPageLoader} />
);

export default FullPageLoader;
